import { Deserializable } from '../../deserializable';
import { ReferenceDataLabels } from './../../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from './../../../constants/reference-data-option-lists';

export class ArtefactActivityDto implements Deserializable {
  public MortgageApplicationId: string;
  public ActivityDate?: Date;
  public UserFullName: string;
  public UserId: string;
  public CompanyName: string;
  public IsExternalSubmission: boolean;
  public StatusCode: string;
  public DecisionType: string;
  public CompanyFsaNumber?: number;
  public CompanyPrincipalFsaNumber?: number;
  public WasAssessmentReleased?: boolean;
  public InterfaceTypeId: number;
  public AxosCaseNumber: string;
  public ReleasedFromAdvised?: boolean;
  public SubmissionDate?: Date;
  public IsPdfBundleAvailable?: boolean;
  public LocalizedStatusCode: string;
  public CanViewRecords: boolean;
  public CanViewAip: boolean;
  public CanViewApp: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.LocalizedStatusCode = this.getActivityStatus(input);
    this.CanViewRecords = this.isPdfAvailable(input) && this.isStatusNotChanged(input);

    return this;
  }

  private getActivityStatus(activity: any): string {
    let status = ReferenceDataLabels.CaseOverviewDecision;
    if (activity.DecisionType === ReferenceDataOptionLists.CaseActivityTypeHumanStatusChange) {
      status = activity.WasAssessmentReleased
        ? ReferenceDataLabels.AssessmentReleased
        : activity.ReleasedFromAdvised
        ? ReferenceDataLabels.ReleasedFromAdvised
        : ReferenceDataLabels.CaseSummaryStatusUpdate;
    }

    return status;
  }

  private isPdfAvailable(activity: any): boolean {
    return activity.IsPdfBundleAvailable && activity.SubmissionDate;
  }

  private isStatusNotChanged(activity: any): boolean {
    return (
      activity.DecisionType !== ReferenceDataOptionLists.CaseActivityTypeHumanStatusChange &&
      activity.DecisionType !== ReferenceDataOptionLists.CaseActivityTypeSystemStatusChange
    );
  }
}
